import { render, staticRenderFns } from "./Tiles.vue?vue&type=template&id=07d2b5a3&functional=true&"
import script from "./Tiles.vue?vue&type=script&lang=ts&"
export * from "./Tiles.vue?vue&type=script&lang=ts&"
import style0 from "./Tiles.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports